import AuthLayout from "../AuthLayout";
import mobileIcon from "../../../assets/img/mobile-alt.svg";
import keyIcon from "../../../assets/img/key.svg";
import {Link} from "react-router-dom";
import {Spinner} from "react-bootstrap";
import {useState} from "react";
import api from '../../../shared/utils/auth/Index';
import {useAlert} from "react-alert";

const EnterMobile = ({mobile, setMobile, goToNext}) => {
    let reactAlert = useAlert();

    const [sending, setSending] = useState(false);
    const onSubmit = (e) => {
        e.preventDefault();

        setSending(true);
        let url = '/general/forgot/forgot';
        api.post(url, {mobile: mobile}, (res) => {
            goToNext();

        }, (err) => {
            setSending(false);
            const data = err.data;
            reactAlert.error(data.message);
        });

    }

    return (
        <AuthLayout>
            <form onSubmit={(e) => onSubmit(e)}>

                <div className="row">
                    <div className="col-auto mx-auto">
                        <img src="/logo.png" alt="Logo" className="img-fluid"/>
                    </div>
                </div>

                <div className="row font-irs-b mt-5">
                    <div className="col-auto mx-auto">
                        <div className="row">
                            <div className="col-12 pr-4">
                                شماره موبایل
                            </div>
                        </div>

                        <div className="row align-items-center">
                            <div className="col pl-0">
                                <input type="tel"
                                       value={mobile}
                                       onChange={(e) => setMobile(e.target.value)}
                                       className="auth-input" required/>
                            </div>
                            <div className="col-auto px-0">
                                <div className="auth-icon">
                                    <img src={mobileIcon} className="img-fluid"/>
                                </div>
                            </div>
                        </div>

                        <div className="row align-items-center mt-4">
                            <div className="col-auto mr-auto pl-0">
                                <button className="btn auth-btn font-irs-b">تائید
                                    {sending && <Spinner animation="border"/>}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </AuthLayout>
    )
};

export default EnterMobile;
